import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import { RootState } from '../../../store';
import {
  clearReportingState,
  fetchReportingTransactionMeta,
  fetchTransactionData,
  setClaimStatus,
  setConfigPayer,
  setReportingTransactionMeta,
} from '../../../store/actions/reportingAndAnalyticsActions';
import '../ReportingAndAnalytics.less';
import { DATE_RANGE_CONFIG, REPORTING_CONSTANTS, REPORTING_TYPE_CONSTANTS, REPORT_ROUTE_MAP } from '../reportingUtils/reportingAndAnalyticsConstants';
import TransactionCountGauge from './TranasctionCountGuage';
import TransactionCountFilters from './TransactionCountFilters';
import TransactionCountNavigation from './TransactionCountNavigation';

const TransactionCountReport = (): React.ReactElement => {
  const dispatch = useDispatch();
  const [configuredPayers, setConfiguredPayers] = useState<any[]>([]);
  const [availableStatus, setAvailableStatus] = useState<any[]>([]);
  const [sections, setSections] = useState<any[]>([]);
  const [activeSection, setActiveSection] = useState('');
  const [transactionData, setTransactionData] = useState({});
  const [successFullMetaCall, setSuccessFullMetaCall] = useState(false);
  const [refreshedInfo, setRefreshedInfo] = useState({});
  const { transactionReportFilters }: any = useSelector(
    (state: RootState): any => state.reportingAndAnalytics,
  );
  const getSections = (data: any): void => {
    setSections(data);
  };
  const getConfiguredPayers = (): any[] => {
    const configuredPayersList = ApplicationDetail.instance.getConfiguredPayer();
    if (configuredPayersList) {
      return (
        configuredPayersList?.reduce((acc: any[], payer: any): any[] => {
          acc?.push({ label: payer?.name, value: payer?.uniqueIdentifier });
          return acc;
        }, []) || []
      );
    }
    return [];
  };

  const getAvailableStatus = (): any[] => {
    const availableStatusList = localStorage.getItem('payerClaimStatuses');
    if (availableStatusList) {
      const parsed = JSON?.parse(availableStatusList);
      return parsed?.reduce((acc: any[], status: any): any[] => {
        if (status?.viewTypes?.includes('ReportingView')) {
          acc?.push({ label: status?.status, value: `${status?.statusId}` });
        }
        return acc;
      }, []);
    }

    return [];
  };
  const successCallback = (
    data: any,
    dataAvailableFrom: string,
    dataRefreshedOn: string,
    lastRefreshedOn: string,
  ): void => {
    if (
      !isEmpty(data)
    ) {
      setTransactionData(data);
      setRefreshedInfo({
        dataAvailableFrom,
        dataRefreshedOn,
        lastRefreshedOn,
      });
    } else {
      setTransactionData({});
      setRefreshedInfo({});
    }
  };
  const successMetaData = (data: Record<string, any>): void => {
    const { dashboardData } = data;
    dispatch(setReportingTransactionMeta(dashboardData));
  };

  const successFullMetaCallback = (flag: boolean): void => {
    setSuccessFullMetaCall(flag);
  };
  const {
    location: { pathname },
  } = useHistory();
  const tabName = REPORT_ROUTE_MAP[pathname];

  useEffect((): void => {
    const PayersList = getConfiguredPayers();
    const statusList = getAvailableStatus();
    dispatch(clearReportingState());
    setConfiguredPayers(PayersList);
    setAvailableStatus(statusList);
    dispatch(setConfigPayer(PayersList));
    dispatch(setClaimStatus(statusList));
    dispatch(
      fetchReportingTransactionMeta({
        successFullMetaCallback,
        successMetaData,
        tabName,
      }),
    );
  }, []);

  useEffect((): void => {
    if (successFullMetaCall) {
      dispatch(
        fetchTransactionData({
          successCallback,
          configuredPayers,
          availableStatus,
        }),
      );
    }
  }, [transactionReportFilters, successFullMetaCall]);

  return (
    <div className="three-part-container">
      <div className="left-section hide-scrollbar">
        <TransactionCountFilters
          configuredPayers={configuredPayers}
          availableStatus={availableStatus}
          statusFilterLabel={REPORTING_CONSTANTS.CLAIM_STATUS}
          dateRangeConfig={DATE_RANGE_CONFIG}
        />
      </div>
      <div className="middle-section hide-scrollbar">
        <TransactionCountGauge
          getSections={getSections}
          setActiveSection={setActiveSection}
          configuredPayers={configuredPayers}
          availableStatus={availableStatus}
          transactionData={transactionData}
          reportType={REPORTING_TYPE_CONSTANTS.TRANSACTION_COUNT}
        />
      </div>
      <div className="right-section hide-scrollbar">
        <TransactionCountNavigation
          sections={sections}
          activeSection={activeSection}
          configuredPayers={configuredPayers}
          availableStatus={availableStatus}
          refreshedInfo={refreshedInfo}
        />
      </div>
    </div>
  );
};

export default TransactionCountReport;
